<template>
    <Editable
        :tooltip="tooltip"
        :large="true"
        @start-editing="startEditing"
        @save="save"
    >

        <template #input>
            <CostTypeSelect
                ref="multiselect"
                v-model="value_"
            />
        </template>

        <template #preview>
            <slot />
        </template>

    </Editable>
</template>

<script>
import CostTypeSelect from '@/components/CostTypeSelect';
import Editable from '@/components/Editable';

export default {

    components: {
        CostTypeSelect,
        Editable,
    },

    props: {
        tooltip: {
            type: String,
            default: '',
        },
        value: {
            type: Object,
            default: () => { },
        },
    },

    data() {
        return {
            value_: {},
        };
    },

    methods: {
        startEditing() {
            this.value_ = this.value;
            setTimeout(() => {
                this.$refs.multiselect.focusSelect();
            }, 100);
        },
        save({ done }) {
            this.$emit('save', {
                value: this.value_ ? this.value_.id : null,
                isDirty: this.value_ !== this.value,
                done,
            });
        },
    },

};
</script>
 
